import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <>
      <header className="headerContainer">
        <Link to="/" className="headerTitle canvas">
          gospeldownloads
        </Link>
      </header>
    </>
  );
};
